import React from "react";

/**
 * Widths of the placeholder pills, varied so the strip reads like real category labels.
 */
const SHIMMER_ITEM_WIDTHS = [
  "w-[70px]",
  "w-[92px]",
  "w-[104px]",
  "w-[76px]",
  "w-[86px]",
  "w-[68px]",
  "w-[62px]",
  "w-[96px]",
  "w-[82px]",
  "w-[66px]",
  "w-[102px]",
  "w-[74px]",
  "w-[84px]",
];

/**
 * Loading placeholder for the desktop mega menu strip.
 *
 * The menu tree is fetched on the client, so the strip would otherwise render as an empty
 * bordered band. Each pill carries the same font size as a real menu label and a
 * non-breaking space, so its height matches the loaded row and the strip does not shift.
 *
 * @returns {JSX.Element} MegaMenuShimmer component.
 */
const MegaMenuShimmer = () => {
  return (
    <div className="flex w-full items-center gap-30 py-2" role="status">
      {SHIMMER_ITEM_WIDTHS.map((widthClass, index) => (
        <span
          key={`mega-menu-shimmer-${index}`}
          className={`inline-block animate-wave rounded-full bg-gradient-to-r from-grey-300 via-grey-100 to-grey-300 bg-[length:200%_100%] text-12 motion-reduce:animate-none xl:text-14 ${widthClass}`}
          aria-hidden="true"
        >
          &nbsp;
        </span>
      ))}
      <span className="sr-only">Loading menu categories</span>
    </div>
  );
};

export default React.memo(MegaMenuShimmer);
